import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';

export const RewardsTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();
  return (
    <>
      <p>
        <span>{t('rewards.checkOutThe')} </span>
        <strong>{t('rewards.titleUpperCase')} </strong>
        <span>{t('rewards.forDaily')} </span>
        <strong>{t('common.free')} </strong>
        <span>{t('common.gifts')}</span>
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('common.exciting')}
      </Button>
    </>
  );
};
